import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronLeft, Heart } from "lucide-react";

const Widerrufsrecht = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-medical-50 via-white to-medical-100">
      {/* Header */}
      <header className="border-b border-border/40 bg-background/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-primary">
            MediQR
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ChevronLeft className="mr-2 h-4 w-4" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-background/60 backdrop-blur-sm rounded-2xl shadow-lg p-8 md:p-12 border border-border/50">
          <h1 className="text-4xl font-bold text-foreground mb-6">
            Widerrufsbelehrung
          </h1>
          
          <div className="space-y-8 text-muted-foreground">
            {/* Widerrufsrecht */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Widerrufsrecht
              </h2>
              <div className="space-y-3">
                <p>
                  Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. 
                  Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
                </p>
                <p>
                  Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (DiekerIT, Zum roten Berge 19, 48165 Münster, 
                  E-Mail:{" "}
                  <a href="mailto:R.Dieker@DiekerIT.com" className="text-primary hover:underline">
                    R.Dieker@DiekerIT.com
                  </a>
                  ) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) 
                  über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte 
                  Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
                </p>
                <p>
                  Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des 
                  Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                </p>
              </div>
            </section>

            {/* Folgen des Widerrufs */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Folgen des Widerrufs
              </h2>
              <div className="space-y-3">
                <p>
                  Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, 
                  einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass 
                  Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), 
                  unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über 
                  Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
                </p>
                <p>
                  Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion 
                  eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall 
                  werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
                </p>
              </div>
            </section>

            {/* Besondere Hinweise */}
            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Besondere Hinweise zum Erlöschen des Widerrufsrechts
              </h2>
              <div className="space-y-3">
                <p>
                  Ihr Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen 
                  Datenträger befindlichen digitalen Inhalten (wie der Zugang zur App), wenn Sie ausdrücklich zugestimmt 
                  haben, dass wir mit der Ausführung des Vertrages vor Ablauf der Widerrufsfrist beginnen, und Sie Ihre 
                  Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit dem Beginn der Ausführung Ihr 
                  Widerrufsrecht verlieren.
                </p>
                <p className="text-sm italic">
                  (Diese Zustimmung wird technisch beim Bestellprozess abgefragt und muss dort protokolliert werden.)
                </p>
              </div>
            </section>

            {/* Muster-Widerrufsformular */}
            <section className="bg-background/80 p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                Muster-Widerrufsformular
              </h2>
              <div className="space-y-3">
                <p className="text-sm italic mb-4">
                  (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)
                </p>
                <div className="bg-background p-6 rounded border border-border/50 font-mono text-sm space-y-4">
                  <p>An</p>
                  <p>
                    DiekerIT<br />
                    Zum roten Berge 19<br />
                    48165 Münster<br />
                    E-Mail: R.Dieker@DiekerIT.com
                  </p>
                  <p className="pt-4">
                    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der 
                    folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
                  </p>
                  <p>Bestellt am (*)/erhalten am (*)</p>
                  <p>Name des/der Verbraucher(s)</p>
                  <p>Anschrift des/der Verbraucher(s)</p>
                  <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>
                  <p>Datum</p>
                  <p className="text-xs mt-4">(*) Unzutreffendes streichen.</p>
                </div>
              </div>
            </section>

            {/* Wichtiger Hinweis */}
            <section className="bg-accent/20 p-6 rounded-lg border border-accent/50">
              <h3 className="text-lg font-semibold text-foreground mb-3">
                Wichtiger Hinweis
              </h3>
              <p className="text-sm">
                Diese Widerrufsbelehrung entspricht den gesetzlichen Vorgaben nach § 312g BGB i.V.m. § 246a EGBGB. 
                Bitte beachten Sie, dass das Widerrufsrecht unter bestimmten Umständen erlöschen kann, insbesondere 
                wenn Sie der sofortigen Leistungserbringung vor Ablauf der Widerrufsfrist ausdrücklich zugestimmt haben.
              </p>
            </section>

            {/* Stand */}
            <section>
              <p className="text-sm text-muted-foreground">
                Stand: November 2025
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-background/60 backdrop-blur-sm mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col items-center space-y-4">
            <div className="text-2xl font-bold text-primary">MediQR</div>
            <div className="flex gap-6 text-sm text-muted-foreground">
              <Link to="/impressum" className="hover:text-foreground transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-foreground transition-colors">
                Datenschutz
              </Link>
              <Link to="/agb" className="hover:text-foreground transition-colors">
                AGB
              </Link>
              <Link to="/widerrufsrecht" className="hover:text-foreground transition-colors">
                Widerrufsrecht
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Widerrufsrecht;
